import React from 'react';
import { motion } from 'framer-motion';
import { Cabin } from '../types/cabin';
interface MiniCabinCardProps {
  cabin: Cabin;
  onSelect: (id: string) => void;
}
export function MiniCabinCard({
  cabin,
  onSelect
}: MiniCabinCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 35
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.8
  }} onClick={() => onSelect(cabin.id)} role="button" tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter') onSelect(cabin.id);
  }} className="group relative rounded-3xl overflow-hidden h-[200px] sm:h-[250px] cursor-pointer transition-transform duration-300 hover:-translate-y-1" data-id="element-315" data-mp="3rvkvmmcrfmv5">
      <img src={cabin.image} alt={cabin.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-316" data-mp="aj8r99p21dod" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" data-id="element-317" data-mp="2cesst8hgkrt4" />
      <div className="absolute bottom-5 left-5 right-5" data-id="element-318" data-mp="2hnxzgnp8zvvt">
        <h3 className="font-display text-xl font-normal text-white" data-id="element-319" data-mp="2mkwrn0pcpsrd">{cabin.name}</h3>
        <p className="text-[0.67rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-320" data-mp="2rksxz6litwa3">{cabin.cardSubtitle}</p>
      </div>
    </motion.div>;
}